import { render, staticRenderFns } from "./EditPersonTeamDialog.vue?vue&type=template&id=1a155c89&scoped=true&"
import script from "./EditPersonTeamDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonTeamDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a155c89",
  null
  
)

export default component.exports